import { useMsal } from '@azure/msal-react';
import { nameToInitials } from '../../../lib/util';
import { Avatar, Dropdown } from '@bphxd/ds-core-react';
import classes from './ProfileAvatar.module.scss';
import { DropdownItem, DropdownMenu } from 'reactstrap';
import { useHasTarAdminAccess } from '../../../lib/util/auth';

const ProfileAvatar = () => {
  const { accounts } = useMsal();
  const hasTarAdminAccess = useHasTarAdminAccess();
  const initials = nameToInitials(accounts?.[0]?.name || '');

  return (
    <div className="d-flex align-items-center justify-content-center">
      <Dropdown className={classes.avatar}>
        <Avatar initials={initials} size="sm" dropdown={hasTarAdminAccess} />
        <DropdownMenu
          end
          style={{
            width: '255px',
          }}
        >
          {hasTarAdminAccess ? (
            <>
              <DropdownItem header>Modify Members</DropdownItem>
              <Dropdown.Item href="https://portal.azure.com/#view/Microsoft_AAD_IAM/GroupDetailsMenuBlade/~/Overview/groupId/bd53e628-bf79-4e4e-b661-118bb8b1ab53/menuId/">
                <span>Read Only</span>
              </Dropdown.Item>
              <Dropdown.Item href="https://portal.azure.com/#view/Microsoft_AAD_IAM/GroupDetailsMenuBlade/~/Overview/groupId/63f12fff-198f-4016-956e-11b890a4ca5a/menuId/">
                <span>Write Access </span>
              </Dropdown.Item>
              <Dropdown.Item href="https://portal.azure.com/#view/Microsoft_AAD_IAM/GroupDetailsMenuBlade/~/Overview/groupId/a3b2f7d8-4b50-492e-9fd2-40eb028860c2/menuId/">
                <span>Admin Access </span>
              </Dropdown.Item>
            </>
          ) : (
            <Dropdown.Item>
              <span>No Actions For Your Role </span>
            </Dropdown.Item>
          )}
        </DropdownMenu>
      </Dropdown>
    </div>
  );
};

export default ProfileAvatar;
